module.exports = {
  // Todo: svgcanvas.js also sets and checks: show_outside_canvas, selectNew; add here?
  // Change the following to preferences and add pref controls to the UI (e.g., initTool, wireframe, showlayers)?
  debug: INKIVE.C.IS_DEV,
  wrapper: '#ik-editor',
  workarea: '#workarea',
  editor: '#editor',
  canvasName: 'default',
  canvasElem: '#svgcanvas',
  canvasPanel: '#canvaspanel',
  canvas_expansion: 1, // Now ignore it only 1
  initText: {
    input: '#text',
    textOverflow: '#text-overflow-textarea'
  },
  initBackground: {
    url: null,
    stroke: 'none',
    fill: 'url(#transparencypattern)'
  },
  initFill: {
    color: '#F0EEFC', // Brand > Lightest
    opacity: 1
  },
  initStroke: {
    width: 2,
    color: '#6659E3', // Brand > Primary
    opacity: 1
  },
  initOpacity: 1,
  colorPickerCSS: null,
  initTool: 'select',
  wireframe: false,
  showlayers: false,
  no_save_warning: false,
  // PATH CONFIGURATION
  // The following path configuration items are disallowed in the URL (as should any future path configurations)
  basePath: INKIVE.C.BASE_URL + 'assets/js/editor/core/',
  imgPath: 'images/',
  langPath: 'locale/',
  extPath: 'extensions/',
  jGraduatePath: 'jgraduate/images/',
  // DOCUMENT PROPERTIES
  // Change the following to a preference (already in the Document Properties dialog)?
  margin: [100, 100],
  dimensions: [INKIVE.width, INKIVE.height],
  // EDITOR OPTIONS
  // Change the following to preferences (already in the Editor Options dialog)?
  gridSnapping: false,
  gridColor: '#000000',
  baseUnit: 'px',
  snappingStep: 10,
  //        showRulers: true,
  // URL BEHAVIOR CONFIGURATION
  preventAllURLConfig: false,
  preventURLContentLoading: false,
  // EXTENSION CONFIGURATION (see also preventAllURLConfig)
  lockExtensions: false, // Disallowed in URL setting
  noDefaultExtensions: false, // noDefaultExtensions can only be meaningfully used in config.js or in the URL
  // EXTENSION-RELATED (GRID)
  showGrid: false, // Set by ext-grid.js
  // EXTENSION-RELATED (STORAGE)
  noStorageOnLoad: false, // Some interaction with ext-storage.js; prevent even the loading of previously saved local storage
  forceStorage: false, // Some interaction with ext-storage.js; strongly discouraged from modification as it bypasses user privacy by preventing them from choosing whether to keep local storage or not
  emptyStorageOnDecline: false, // Used by ext-storage.js; empty any prior storage if the user declines to store
  string: {
    noTextInput: 'Can not found input element.'
  }
};
